import { render, staticRenderFns } from "./speaker.vue?vue&type=template&id=59783dbc&scoped=true&"
var script = {}
import style0 from "./speaker.vue?vue&type=style&index=0&id=59783dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59783dbc",
  null
  
)

export default component.exports